import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.logisticsType === 'edit' ? '修改' : '新增',
    width: "500px",
    modelValue: _ctx.logisticsDialogVisible,
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    "custom-class": "dialog-width-small el-dialog-inner-scroll",
    top: "5vh",
    onOpen: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleOpen())),
    onClose: _ctx.handleCancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, { onClick: _ctx.handleCancel }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.confirmUpdate
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-width": "100px",
        ref: "refForm",
        rules: _ctx.rules,
        model: _ctx.choosedItem
      }, {
        default: _withCtx(() => [
          (['addChild'].includes(_ctx.logisticsType))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "一级名称："
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    disabled: "",
                    modelValue: _ctx.firstName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "物流名称：",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.choosedItem.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.choosedItem.name) = $event)),
                placeholder: "请输入物流名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onClose"]))
}